<template>
  <p>
    По данным от Texterra и Craftum:
  </p>
  <ul class="marked-ul">
    <li>ChatGPT, Google Gemini, Claude являются лидерами в глобальном рейтинге, специализируясь на генерации текста и
      решении различных задач.
    </li>
    <li>Perplexity AI популярна за свою способность находить источники в интернете и избегать выдуманных фактов.</li>
    <li>MidJourney, Stable Diffusion: генераторы фотореалистичных изображений.</li>
  </ul>
  <p>
    Отталкивайтесь от задачи, не все задачи одинаково решаются разными нейросетями. Для каждого случая выбирайте
    наиболее подходящую нейросеть.
  </p>
  <p>
    Если не знаете что выбрать - выбирайте Gpt 4o mini или Claude Haiku, хорошее соотношение цена - качество.
  </p>
  <p>
    Если задача посложнее или не устраивает результат - выбирайте Claude 3.5 Sonnet или Gpt 4o.
  </p>
</template>